import { Modal } from '@scale/scaleui';
import { Attachment, ModelInputFileAttachmentType } from '@scale/shared/types/chat';
import { useChatThemeStore } from 'react-scale/components/scalers/tasks/ThreadedInteraction/hooks/useChatThemeStore';
import EditAttachments from './EditAttachments';
import { MultimodalImageServiceHook } from 'react-scale/components/scalers/tasks/ThreadedInteraction/hooks/useMultimodalImageService';
import { MultimodalAssetDto } from '@scale/mm-shared';

type EditAttachmentsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  attachments: Attachment[];
  setAttachments: (attachment: Attachment[]) => void;
  supportedMimeTypesByInputType: Record<ModelInputFileAttachmentType, string[]>;
  multimodalImageServiceHook?: MultimodalImageServiceHook;
  shouldMirrorImageUrlsToTempBucket?: boolean;
  enableAttachments?: boolean;
  enableImageUrls?: boolean;
  enableMmImageService?: boolean;
  updateImageMetadata?: (url: string, metadata: MultimodalAssetDto) => void;
  fileSizeLimitInBytes?: number;
  multipleFiles?: boolean;
  title?: string;
  beforeFileProcessing?: () => void;
};

const EditAttachmentsModal = ({
  isOpen,
  onClose,
  setAttachments,
  attachments,
  supportedMimeTypesByInputType,
  multimodalImageServiceHook,
  shouldMirrorImageUrlsToTempBucket,
  enableAttachments,
  enableImageUrls,
  enableMmImageService,
  updateImageMetadata,
  fileSizeLimitInBytes,
  multipleFiles,
  title,
  beforeFileProcessing,
}: EditAttachmentsModalProps) => {
  const theme = useChatThemeStore(state => state.theme);

  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => {
          onClose();
        }}
        theme={theme}
        title={title || 'Add attachments'}
      >
        <EditAttachments
          setAttachments={setAttachments}
          attachments={attachments}
          supportedMimeTypesByInputType={supportedMimeTypesByInputType}
          shouldMirrorImageUrlsToTempBucket={shouldMirrorImageUrlsToTempBucket}
          enableAttachmentsOverride={enableAttachments}
          enableImageUrlsOverride={enableImageUrls}
          enableMmImageServiceOverride={enableMmImageService}
          multimodalImageServiceHook={multimodalImageServiceHook}
          updateImageMetadata={updateImageMetadata}
          fileSizeLimitInBytes={fileSizeLimitInBytes}
          multipleFiles={multipleFiles}
          beforeFileProcessing={beforeFileProcessing}
        />
      </Modal>
    </>
  );
};

export default EditAttachmentsModal;
